<script>
    import { Route } from 'yrv'
    import PrivateRouteGuard from './PrivateRouteGuard.svelte'

    export let path
    export let exact = null
</script>

<Route {path} {exact}>
    <PrivateRouteGuard>
        <slot />
    </PrivateRouteGuard>
</Route>
